import {z} from 'zod';

import {Nullish} from 'shared/web';

const CheckoutMessageOrderPayloadSchema = z.object({
  orders: z
    .array(
      z.object({
        orderId: z.string(),
        items: z.array(z.object({name: z.string()})).min(1),
      })
    )
    .min(1),
});

export interface CheckoutMessageOrderSummary {
  orderId: string;
  itemName: string;
}

export const getCheckoutMessageOrderSummary = (
  payload: Record<string, unknown> | Nullish
): CheckoutMessageOrderSummary | null => {
  const parsedPayload = CheckoutMessageOrderPayloadSchema.safeParse(payload);

  if (!parsedPayload.success) {
    return null;
  }

  const [firstOrder] = parsedPayload.data.orders;
  const [firstItem] = firstOrder.items;

  return {orderId: firstOrder.orderId, itemName: firstItem.name};
};
